/*
 * Wraps a dispatcher by tying it to a context.
 */
(function() {
    'use strict';

    angular.module('paysera.toast').factory('toastDispatcherCreator', toastDispatcherCreatorFactory);

    toastDispatcherCreatorFactory.$inject = ['toastDispatcher', 'messageResolver'];

    function toastDispatcherCreatorFactory(toastDispatcher, messageResolver) {
        return {
            create: function(context) {
                return new Dispatcher(context);
            }
        };

        /**
         * @param {!String} context
         * @constructor
         */
        function Dispatcher(context) {
            this.error = error;
            this.success = success;
            this.resolveMessage = resolveMessage;

            // ---

            function error(message) {
                toastDispatcher.error(resolveMessage(message));
            }

            function success(message) {
                toastDispatcher.success(resolveMessage(message));
            }

            function resolveMessage(message) {
                return messageResolver.resolve(message, context);
            }
        }
    }
})();
